import React from "react";
import propTypes from "prop-types";

export default function Button({
  className = "",
  children,
  background_color = "",
  text_color = "",
  border = "",
  type = "button",
  font_size = "",
  onClick = null,
}) {
  switch (background_color) {
    case "white":
      background_color = "background-white";
      break;
    case "yellow":
      background_color = "background-yellow";
      break;
    case "red":
      background_color = "background-red";
      break;
    case "gray":
      background_color = "background-gray";
      break;
    case "black":
      background_color = "background-black";
      break;
    default:
      background_color = "transparent";
      break;
  }

  switch (text_color) {
    case "white":
      text_color = "color-white";
      break;
    case "yellow":
      text_color = "color-yellow";
      break;
    case "red":
      text_color = "color-red";
      break;
    default:
      text_color = "color-black";
      break;
  }

  switch (border) {
    case "white":
      border = "border-white";
      break;
    case "yellow":
      border = "border-yellow";
      break;
    case "red":
      border = "border-red";
      break;
    case "gray":
      border = "border-gray";
      break;
    case "gray-2":
      border = "border-gray-2";
      break;
    default:
      border = "border-none";
      break;
  }

  switch (font_size) {
    case "size-1":
      font_size = "size-1";
      break;
    case "size-2":
      font_size = "size-2";
      break;
    case "size-3":
      font_size = "size-3";
      break;
    default:
      font_size = "size-1";
      break;
  }

  return (
    <button
      className={`${className} ${background_color} ${text_color} ${
        border !== "" ? border : ""
      } ${font_size} custom-button`}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
}

Button.defaultProps = {
  className: "",
  background_color: "",
  text_color: "",
  type: "button",
  border: "",
  font_size: "",
  onClick: null,
};

Button.propTypes = {
  className: propTypes.string,
  background_color: propTypes.string,
  text_color: propTypes.string,
  type: propTypes.string,
  border: propTypes.string,
  font_size: propTypes.string,
  onClick: propTypes.func,
};
